export class HomeAvisDePubMessages {
  public content = 'home.content';
  public eventThread = 'home.event_thread';
  public news = 'home.news';
  public access = 'home.access';
  public welcome = 'homeAvisDePub.welcome';
  public lister = 'homeAvisDePub.lister';
  public creer = 'homeAvisDePub.creer';
  public preferences = 'homeAvisDePub.preferences';
  public lister_desc = 'homeAvisDePub.lister_desc';
  public creer_desc = 'homeAvisDePub.creer_desc';
  public preferences_desc = 'homeAvisDePub.preferences_desc';
  public lister_aria='Accéder à la liste des avis';
  public creer_aria='Accéder à la création d`un nouvel avis';
  public preferences_aria='Accéder aux préférences';
  constructor() {
  }
}
